import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { Draggable } from "gsap/all";
import BasicLayout from "../layouts/Basic";
import Responsive from "../layouts/Responsive";

import Title from "../components/Title";
import Livid from "../sketches/Livid.jsx";
import Alert from "../assets/image/alert.png";
const colors = ["livid", "livid."];

const Lightning = () => {
  const [inputValue, setInputValue] = useState("");
  const [currentColor, setCurrentColor] = useState("");
  const [originalColor, setOriginalColor] = useState("#191020");

  const [modalIsOpen, setmodalIsOpen] = useState(false);

  const handleInputChange = (e) => {
    const inputColor = e.target.value.toLowerCase();
    setInputValue(inputColor);
  };

  const handleConfirmButtonClick = () => {
    const inputColor = inputValue.toLowerCase();
    if (colors.includes(inputColor)) {
      setCurrentColor(inputColor);
      setmodalIsOpen(false);
      // setInputValue("");
    } else {
      setmodalIsOpen(true);
    }
  };

  const drag = useRef();

  useEffect(() => {
    gsap.registerPlugin(Draggable);

    let ctx = gsap.context(() => {
      // use scoped selectors
      Draggable.create(".alert-img", {});

      return () => ctx.revert();
    }, drag);

    if (currentColor) {
      gsap.to(".box", {
        backgroundColor: "#83A9F4",
        duration: 0.5,
        ease: "back",
      });

      gsap.fromTo(
        ".lightning-text",
        {
          scale: 3.3,
          ease: "power4",
          color: "#7C503C",
        },
        {
          scale: 1,
          ease: "power4",
        }
      );

      gsap.to(".lightning-input", {
        color: "#7C503C",
      });

      setTimeout(() => {
        gsap.to(".box", {
          backgroundColor: originalColor,
          duration: 0.5,
          ease: "power4",
        });
        gsap.to(".lightning-text", {
          color: "#A51F7F",
          ease: "power4",
        });
        gsap.to(".lightning-input", {
          color: "#ffffff",
        });
        setCurrentColor("");
      }, 3000);
    }
  }, [currentColor, originalColor]);

  gsap.to(".alert-img", {
    x: "random(-200, 200)",
    y: "random(-200, 200)",
    ease: "back",
  });

  return (
    <>
      <Responsive />
      <div className="book-wrapper">
        <div className="box">
          {/* <Title /> */}
          <div className="contents-wrapper">
            <div className="canvas-wrapper">
              <Livid />
            </div>
            <div className="element-wrapper" ref={drag}>
              {modalIsOpen && (
                <img
                  className="alert-img"
                  src={Alert}
                  alt='alert! The only color you can enter is "livid".'
                />
              )}
              <div className="lightning-wrapper">
                <div className="text-box">
                  <p className="lightning-text">
                    The lightning made <br />
                    the town look <br />
                  </p>
                  <div className="input-box">
                    <input
                      type="text"
                      className="lightning-input"
                      placeholder="enter the color"
                      maxLength="16"
                      value={inputValue}
                      onChange={handleInputChange}
                      onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                          handleConfirmButtonClick();
                        }
                      }}
                    ></input>
                    <button
                      type="button"
                      className="lightning-button confirm"
                      onClick={handleConfirmButtonClick}
                    >
                      {/* <img src={Arrow} alt="confirm" /> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BasicLayout />
      </div>
    </>
  );
};

export default Lightning;
